/** Max selection / batch limits for ticket management (reserved for future use). */
export const TICKET_MANAGEMENT_MAX_SELECTION = 10000;

export const INTERNAL_TICKET_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Chip colors for list row status labels (lowercase keys). */
export const TICKET_ROW_STATUS_STYLE_MAP = {
  open: { bg: '#c30a0a20', text: 'black' },
  pending: { bg: '#ff990020', text: 'black' },
  resolved: { bg: '#4caf5020', text: 'black' },
  closed: { bg: '#9e9e9e20', text: 'black' },
  'waiting on customer': { bg: '#1976d220', text: '#1976d2' },
  'waiting on third party': { bg: '#6a1b9a20', text: '#6a1b9a' }
};

export const TICKET_ROW_STATUS_FALLBACK_STYLE = { bg: '#f0f0f0', text: '#333' };

/** Stats header colors by label (when stats UI is enabled). */
export const TICKET_STATS_LABEL_COLOR_MAP = {
  Open: '#08306B',
  Pending: '#FFA500',
  Resolved: '#568203',
  Closed: '#08306B',
  'Waiting on Bank': '#420D09'
};

/** Add-ticket modal container `sx`. */
export const addTicketModalBoxSx = {
  width: '100%',
  maxWidth: { sm: '90%', xs: '90%', md: 600 },
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #ddd',
  boxShadow: 24,
  p: 3,
  borderRadius: 2
};

/** Must match PATCH / ticket-management validation on the backend. */
export const TICKET_STATUS_API_VALUES = [
  'Open',
  'Pending',
  'Resolved',
  'Closed',
  'Waiting on customer',
  'Waiting on third party'
];

export const ADD_TICKET_COMPLAINT_TYPE_OPTIONS = [
  { label: 'Announcement issue/Sound issue', value: 'Announcement issue/Sound issue' },
  { label: 'Battery Issue', value: 'Battery Issue' },
  { label: 'Charging Issue', value: 'Charging Issue' },
  { label: 'Mapping Issue', value: 'Mapping Issue' },
  { label: 'Language Change', value: 'Language Change' },
  { label: 'Language Failed', value: 'Language Failed' },
  { label: 'Wrong Qr String', value: 'Wrong Qr String' },
  { label: 'QR Issue', value: 'QR Issue' },
  { label: 'Delivery Issue', value: 'Delivery Issue' },
  { label: 'Network Issue', value: 'Network Issue' },
  { label: 'Surrender', value: 'Surrender' },
  { label: 'RTO', value: 'RTO' },
  { label: 'Duplicate', value: 'Duplicate' },
  { label: 'Spam', value: 'Spam' },
  { label: 'Portal Issue', value: 'Portal Issue' },
  { label: 'Api Issue', value: 'Api Issue' },
  { label: 'Device Damaged', value: 'Device Damaged' },
  { label: 'Multiple Issues', value: 'Multiple Issues' },
  { label: 'Internal Ticket', value: 'Internal Ticket' },
  { label: 'CWD Device', value: 'CWD Device' },
  { label: 'Customer Details Change', value: 'Customer Details Change' }
];

export const TICKET_MANAGEMENT_OPTIONS ={
  LOAD: 'LOAD',
  SEARCH: 'SEARCH',
  FILTER: 'FILTER'
}
